import { ClipLoader } from 'react-spinners';

/** @satisfies {React.FC<{ color?: string, small?: boolean, message?: string }>} */
export const LoadingPanel = ({ message = 'Laster...', small = false, color = '' }) => (
  <span>
    {!small && (
      <div className="loading-panel">
        <div className="spinner">
          <ClipLoader color={color ? color : '#1fa3ff'} size={28} cssOverride={{ margin: '4px' }} />
        </div>
        <div className="text">
          <span>{message}</span>
        </div>
      </div>
    )}
    {small && (
      <div className="loading-panel small">
        <ClipLoader color={color ? color : '#fff'} size={12} cssOverride={{ margin: '4px' }} />
      </div>
    )}
  </span>
);
